var map = {
	"./academic/academic.module": [
		"./src/app/academic/academic.module.ts"
	],
	"./account/account.module": [
		"./src/app/account/account.module.ts"
	],
	"./adminision/adminision.module": [
		"./src/app/adminision/adminision.module.ts"
	],
	"./affairs/affairs.module": [
		"./src/app/affairs/affairs.module.ts"
	],
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts",
		"auth-auth-module"
	],
	"./card/card.module": [
		"./src/app/card/card.module.ts"
	],
	"./exams/exams.module": [
		"./src/app/exams/exams.module.ts",
		"exams-exams-module"
	],
	"./military/military.module": [
		"./src/app/military/military.module.ts",
		"military-military-module"
	],
	"./settings/settings.module": [
		"./src/app/settings/settings.module.ts"
	],
	"./student/student.module": [
		"./src/app/student/student.module.ts"
	],
	"./user/user.module": [
		"./src/app/user/user.module.ts",
		"user-user-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;